import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";
import { waLink } from "@/lib/site";

export const WhatsAppFloat = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-floating-button"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          whileHover={{ scale: 1.08 }}
          transition={{ type: "spring", stiffness: 260, damping: 18 }}
          className="fixed bottom-6 right-6 z-50 grid place-items-center"
        >
          <span className="relative grid place-items-center h-14 w-14 rounded-full bg-[#25D366] shadow-[0_10px_30px_rgba(37,211,102,0.5)] pulse-ring">
            <svg viewBox="0 0 32 32" className="h-7 w-7 fill-white relative z-10">
              <path d="M16.004 2.667c-7.36 0-13.333 5.973-13.333 13.333 0 2.347.613 4.64 1.777 6.667L2.667 29.333l6.84-1.787a13.27 13.27 0 006.497 1.653h.005c7.355 0 13.329-5.973 13.329-13.333 0-3.563-1.387-6.907-3.907-9.427-2.52-2.52-5.867-3.773-9.427-3.773zm7.813 18.947c-.333.933-1.653 1.787-2.72 1.92-.72.093-1.627.16-4.6-1.013-3.867-1.56-6.333-5.507-6.52-5.76-.187-.253-1.56-2.08-1.56-3.973 0-1.893.987-2.827 1.333-3.213.347-.387.76-.48 1.013-.48.253 0 .507 0 .72.013.24.013.547-.093.853.653.32.773 1.093 2.667 1.187 2.867.093.2.16.427.027.68-.133.253-.2.413-.4.64-.2.227-.42.507-.6.68-.2.2-.407.413-.173.813.233.4 1.04 1.72 2.24 2.787 1.533 1.373 2.827 1.8 3.227 2 .4.2.64.173.867-.093.227-.267.987-1.147 1.253-1.547.267-.4.533-.333.893-.2.36.133 2.28 1.08 2.68 1.28.4.2.667.293.76.453.093.16.093.933-.24 1.867z"/>
            </svg>
          </span>
        </motion.a>
      )}
    </AnimatePresence>
  );
};
